import Vue from 'vue'
import App from './App.vue'
import router from './router' 
import store from './store'
import defaultData from "@/utils/default.js";
import ElementUI, { Loading, Notification } from 'element-ui'
import './assets/style/theme/index.css' //element 框架

import '@/assets/resect/resect.css' //引入重置样式
import '@/assets/style/base.less' //引入重置样式
import * as filters from './utils/filter'
import axios from 'axios'
import local from '@/utils/local.js'
//IM
import tim from './commen/tim/tim.js'
import commen from './commen/commen.js'
import TIM from 'tim-js-sdk'
import './assets/icon/iconfont.css'
import './components/index'
import VueXss from 'vue-xss'

import hls from 'videojs-contrib-hls'
// import VideoPlayer from 'vue-video-player';
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"

Vue.use(hls)
// Vue.use(VideoPlayer)

Vue.use(VueXss)  
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
import Vuetify from 'vuetify';
Vue.use(Vuetify)
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import websocket from './store/websocket'
Vue.prototype.$websocket = websocket; 
Vue.prototype.$defaultData = defaultData;
import VueSocketIO from 'vue-socket.io'
import setEditorText from './commen/setEditorText.js'
import getEditorText from './commen/getEditorText.js'


// 将文本域手动改为富文本编辑器
Vue.prototype.$setEditorText = setEditorText;
Vue.prototype.$getEditorText = getEditorText;
//刷新页面执行
if (local.get('Authorization')) { 
  let vueSocketIO = new VueSocketIO({
    debug: false,//控制台是否打印信息
    connection: `${process.env.VUE_APP_API_WS_URL}?token=${local.get('Authorization') ? local.get('Authorization').slice(7) : '123' }`,
    vuex: {
      store: websocket,
      mutationPrefix: 'SOCKET_',
      actionPrefix: 'SOCKET_'
    }
  })
  Vue.use(vueSocketIO)
}
Vue.prototype.handleHeight = function () {
  let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  const setHeightDom = document.getElementById('setHeightDom');
  let heightTop = 0
  if (setHeightDom) {
    heightTop = setHeightDom.offsetTop
  }
  return h - heightTop - 22
}
//支付方式显示
Vue.prototype.handelPay = filters.handelPay
Vue.filter('filterPay',filters.handelPay)
Vue.filter('money', function (value) {
  if (!value) return '0.00';
  const fixedValue = value.toFixed(2); // 提前保留两位小数
  const [intPart, floatPart = '00'] = fixedValue.split('.'); // 拆分整数部分和小数部分，默认为0
  const intPartFormat = Number(intPart).toLocaleString(); // 将整数部分格式化为千分位
  return `${intPartFormat}.${floatPart.padEnd(2, '0')}`; // 返回处理后的结果
})
//后期优化UI公用css
import '@/assets/style/public.css'
import breadCrumb from '@/components/breadCrumb'
import publicBreadCrumb from '@/components/publicBreadcrumb'
Vue.component('publicBreadCrumb',publicBreadCrumb)
import publicFoldSearch from '@/components/publicSearch/foldSearch'
Vue.component('publicFoldSearch',publicFoldSearch)
import publicExpandSearch from '@/components/publicSearch/expandSearch'
Vue.component('publicExpandSearch',publicExpandSearch)
import baseSearch from '@/components/baseSearch'
import selectHospital from '@/components/selectHospital'
import selectLabel from '@/components/selectLabel'
Vue.component('breadCrumb',breadCrumb)
Vue.component('baseSearch',baseSearch)
Vue.component('selectHospital',selectHospital)
Vue.component('selectLabel',selectLabel)
Vue.config.productionTip = false
Vue.prototype.tim = tim.tim //tim sdk 引入后生成的tim服务
Vue.prototype.$TIM = TIM //tim 的状态/事件 常量
Vue.prototype.$commen = commen
Vue.prototype.switchOpen = false;
Vue.prototype.$machiningTime = time => {
  if (typeof time != 'string') {
    return new Error('Please pass it on String');
  } else {
    return time.substring(0,time.length - 8 ) + `23:59:59`
  }
}

Vue.use(ElementUI)
Vue.config.productionTip = false

/*===============================================================
=                           权限指令                             =
===============================================================*/

Vue.directive('has', {
  bind: function (el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      // el.parentNode.removeChild(el);
      el.style.display = 'none';
    }
  }
});
//权限检查方法
Vue.prototype.$_has = function (value) {
  let isExist = false;
  let buttonperms = store.state.user_info.btns
  // 权限列表
  for (let i = 0; i < buttonperms.length; i++) {
    if (buttonperms[i].indexOf(value) > -1) {
      isExist = true;
      break;
    }
  }
  return isExist;
};
// 自定义指令防止按钮重复点击 v-preventReClick
Vue.directive('preventReClick', {
  inserted:function(el,binding){
    el.addEventListener('click', () => {
      if (el.style['pointer-events'] != 'none') {
          el.style['pointer-events'] = 'none';
          setTimeout(() => {
              el.style['pointer-events'] = 'all';
          }, binding.value || 3000)
      }
    })
   }
})

/*===============================================================
=                        编链弹窗计算天数的方法                  =
===============================================================*/

Vue.prototype.$dayTimeFun = (dayNum) => { //计算天数的方法
  let timeNum = 0;
  if(dayNum == 1){
    timeNum = 1;
  }else if(dayNum == 2){
    timeNum = 5;
  }else if(dayNum == 3){
    timeNum = 2;
  }else if(dayNum == 4){
    timeNum = 6;
  }else if(dayNum == 5){
    timeNum = 3;
  }else if(dayNum == 6){
    timeNum = 7;
  }else if(dayNum == 7){
    timeNum = 4;
  }else if(dayNum == 8){
    timeNum = 8;
  }else if(dayNum == 9){
    timeNum = 9;
  }else if(dayNum == 10){
    timeNum = 10;
  }
  return timeNum;
};
Vue.prototype.$timeNumFun = (dayNum) => { //回显天数的方法
  let timeNum = '';
  if(dayNum == 1){
    timeNum = 1;
  }else if(dayNum == 2){
    timeNum = 3;
  }else if(dayNum == 3){
    timeNum = 5;
  }else if(dayNum == 4){
    timeNum = 7;
  }else if(dayNum == 5){
    timeNum = 2;
  }else if(dayNum == 6){
    timeNum = 4;
  }else if(dayNum == 7){
    timeNum = 6;
  }else if(dayNum == 8){
    timeNum = 8;
  }else if(dayNum == 9){
    timeNum = 9;
  }else if(dayNum == 10){
    timeNum = 10;
  }
  return timeNum;
};
Vue.prototype.$toolsName = (recordTypeId) => {
  let toolTypeName = null;
  let toolTypeNameList = store.state.toolsList.filter((item) => {
    return item.recordTypeId == recordTypeId
  })
  if(toolTypeNameList.length > 0){
    toolTypeName = toolTypeNameList[0].recordTypeName
  }
  return toolTypeName

}
// el-select滚动加载更多
Vue.directive('elSelectloadMore', {
  bind(el, binding) {
    // 获取element，定义scroll
    let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    select_dom.addEventListener('scroll', function () {
      console.log(this.scrollHeight,'scrollHeight')
      console.log(this.scrollTop,'scrollTop')
      console.log(this.clientHeight,'clientHeight')
      let height = this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight;
      console.log(height)
      if (height) {
        binding.value()
      }
    })
  }
})

// 6217001540020243497
// 6217920166658273
/*===============================================================
=                           图片过滤器                            =
===============================================================*/
Vue.filter('assembleImgSrc', (input) => {
  if(!input) return 
  return input.indexOf('http://') != -1 ? input : process.env.VUE_APP_OSS_URL + input
})
Vue.filter('filterValgang', (val) => {
  if(!val) return '--';
  return val
})  

const err = (error) => {
  if (error && error.response && error.response.status) {
    let statusCode = error.response.status * 1
    let errMessage = error.response.data.message
    switch (statusCode) {
      case 400:
        errMessage = '请求错误(400)'
        break
      case 401:
        // if (error.response.data.code === '9000001' || error.response.data.code === 9000001) {
          errMessage = '登录失效，请重新登录'
          router.push({
            path: '/login',
          })
        // }
        break
        default:
        errMessage = error.response.data.message
        break
      // case 403:
      //   errMessage = '拒绝访问(403)';
      //   break;
      // case 404:
      //   errMessage = '请求出错(404)';
      //   break;
      // case 408:
      //   errMessage = '请求超时(408)';
      //   break;
      // case 500:
      //   errMessage = '服务器错误(500)';
      //   break;
      // case 501:
      //   errMessage = '服务未实现(501)';
      //   break;
      // case 502:
      //   errMessage = '网络错误(502)';
      //   break;
      // case 503:
      //   errMessage = '服务不可用(503)';
      //   break;
      // case 504:
      //   errMessage = '网络超时(504)';
      //   break;
      // case 505:
      //   errMessage = 'HTTP版本不受支持(505)';
      //   break;
      // default:
      //   errMessage = "连接出错(" + statusCode + ")!";
      //   break;
    }

    // Notification({
    //   title: statusCode,
    //   message: errMessage || '服务器太拥挤了~请您稍后重试',
    //   type: 'error',
    // })
  }
  return Promise.reject(error,'123123123')
}

// 全局loading声明
let loadingInstance

// 请求拦截
axios.defaults.baseURL = process.env.VUE_APP_API_URL + 'api'
axios.interceptors.request.use((config) => {
  // console.log(config)
  if (config.url.indexOf('auth/oauth/token') > -1 || config.url.indexOf('admin/user/create/doctor/app') > -1 || config.url.indexOf('/dsicm-survey/oss/surveys') > -1||config.url.indexOf('admin/user/create/doctor')>-1 || config.url.indexOf('admin/user/create/simpleDoctor')>-1) {
    return config
  } else {
    if (config.loading) {
      loadingInstance = Loading.service({
        lock: true,
        text: '正在加载中...',
        customClass: 'my-el-custom-loading',
        background:'rgba(255,255,255,.3)',
        target: document.querySelector('.loading-area')
      })
      // 长时间请求未成功则自动关闭
      setTimeout(() => loadingInstance.close(), 60000)
    }  
    
    let token = local.get('Authorization')
    token && (config.headers.Authorization = token)
    config.headers.post['Content-Type'] = 'application/json'
    config.headers.put['Content-Type'] = 'application/json'
    return config
  }
})

//响应拦截
axios.interceptors.response.use((response) => {
  if (loadingInstance) {
    loadingInstance.close()
  }
  return response
  // let message = response.data.message
  // let code = response.data.code
  // if (code > 0 || code == 0 || response.data ) {
  //   return response
  // } else if (code < 0) {
  //   Notification({
  //     title: '错误',
  //     message: '服务器太拥挤了~请您稍后重试',
  //     type: 'error',
  // });
  // }
}, err)

// 导入css文件
import 'vuescroll/dist/vuescroll.css';
// import vuescroll from 'vuescroll/dist/vuescroll-slide';
import vuescroll from 'vuescroll/dist/vuescroll-native';
Vue.use(vuescroll);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
